module.exports = __webpack_public_path__ + "img/04.61976113.png";